import { createContext, useCallback, useContext, useState, ReactNode } from "react";

type ToastType = "info" | "success" | "error";
interface Toast { id: number; text: string; type: ToastType }

interface ToastApi {
  show: (text: string, type?: ToastType) => void;
}

const Ctx = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const v = useContext(Ctx);
  if (!v) throw new Error("ToastProvider missing");
  return v;
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const show = useCallback((text: string, type: ToastType = "info") => {
    const id = Date.now() + Math.random();
    setToasts((cur) => [...cur, { id, text, type }]);
    setTimeout(() => setToasts((cur) => cur.filter((t) => t.id !== id)), 4000);
  }, []);

  return (
    <Ctx.Provider value={{ show }}>
      {children}
      <div>
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.type === "error" ? "error" : t.type === "success" ? "success" : ""}`}>
            {t.text}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}


